<template>
  <div>
    <div v-if="!loadStatus">
      <PaymentMethodLoader />
    </div>
    <template v-if="loadStatus">
      <div v-if="paymentMethods.length">
        <!-- Buttons Here -->
        <div
          class="align-left  margin-top-3"
          style="display: flex; justify-content: right; gap: 1rem"
        >
          <router-link
            tag="button"
            class="whitebutton-gemnote whitebutton-gemnote--small"
            :to="{ name: 'AddInvoicePaymentMethod' }"
          >
            <span>Pay by invoice</span>
          </router-link>
          <router-link
            tag="button"
            class="button-gemnote button-gemnote--small"
            :to="{ name: 'AddPaymentMethod' }"
          >
            <img src="../../assets/add-white.svg" alt="add" class="w-4" />
            <span>Add credit card</span>
          </router-link>
        </div>
        <!-- swag store invoices -->
        <div v-if="false">
          <div class="payment-method header">
            <p class="title">Swag Store</p>
            <p class="subtitle">
              All Swag Store payments, subscriptions, fees and charges will be
              billed to this card.
            </p>
          </div>
          <div class="empty-state">
            <img src="../../assets/warning-info.svg" alt="empty" />
            <p>No card added. Payment method required.</p>
          </div>
        </div>
        <!-- E-commerce invoices -->
        <div v-if="false">
          <div class="payment-method header">
            <p class="title">E-commerce</p>
            <p class="subtitle">
              Only E-commerce payments, fees and charges will be billed to this
              card. This card may also be used for processing payouts and
              surcharges.
            </p>
          </div>
          <div class="empty-state">
            <img src="../../assets/warning-info.svg" alt="empty" />
            <p>No card added. Payment method required.</p>
          </div>
        </div>

        <div>
          <div class="payment-method header mb-0">
            <img src="../../assets/credit-card.svg" alt="info" class="w-5" />
            <p class="title">All payment methods</p>
          </div>
        </div>

        <!-- Table Here -->
        <vue-good-table
          :columns="columns"
          :rows="paymentMethods"
          styleClass="vgt-table striped payment payment-methods-table"
          style="width: 100%"
        >
          <template slot="table-row" slot-scope="paymentMethods">
            <!-- Card Brand Here -->
            <span
              v-if="paymentMethods.column.field === 'brand'"
              class="holder card"
            >
              <img
                :src="mapBrand(paymentMethods.row.brand)"
                class="brand-icon"
                v-if="paymentMethods.row.sourceType === 'card'"
              />
              <span v-else><strong>Accounts Payable</strong></span>
            </span>

            <!-- Last Four Digits Here -->
            <span
              v-else-if="paymentMethods.column.field === 'lastFour'"
              class="holder"
            >
              <p v-if="paymentMethods.row.sourceType === 'card'">
                {{
                  maskCard(
                    paymentMethods.row.brand,
                    paymentMethods.row.lastFour
                  )
                }}
              </p>
              <p v-else>{{ paymentMethods.row.email }}</p>
            </span>

            <!-- Expiry Date here -->
            <span
              v-else-if="paymentMethods.column.field === 'expiryDate'"
              class="holder"
            >
              <p v-if="paymentMethods.row.sourceType === 'card'">
                Expires {{ paymentMethods.row.expiryDate }}
              </p>
              <p v-else>{{ formatPhoneNumber(paymentMethods.row.phone) }}</p>
            </span>

            <!-- Action Section Here -->
            <div
              v-if="paymentMethods.column.field === 'action'"
              class="action-holder"
            >
              <!-- MAke Primary buton here -->
              <button
                v-if="!paymentMethods.row.isPrimary"
                type="button"
                class="make-primary"
                @click.stop="markMethodAsPrimary($event, paymentMethods.row)"
              >
                Make Primary
              </button>

              <!--               Primary Card-->
              <span v-if="paymentMethods.row.isPrimary">Primary card</span>

              <!-- Remove Card here -->
              <div class="flex items-center gap-5">
                <!--                <p class="remove-card">-->
                <!-- <img src="../../assets/trash.svg" alt="delete" /> -->
                <!--                  <PaymentMethodDropdown-->
                <!--                    :data="paymentMethods.row"-->
                <!--                    :key="paymentMethods.row.id"-->
                <!--                  />-->
                <!--                </p>-->
                <p
                  class="remove-card"
                  @click.stop="removePaymentMethod($event, paymentMethods.row)"
                >
                  <img
                    src="../../assets/trash.svg"
                    alt="delete"
                    class="w-4 h-4"
                  />
                </p>
              </div>
            </div>
          </template>
        </vue-good-table>
      </div>
      <div v-else>
        <PaymentMethodsZeroState />
      </div>
    </template>
    <!-- <Pagination
      :total-items="totalRecords"
      :page="serverParams.page"
      :items-per-page="serverParams.perPage"
      @page-change="pageChange"
      @perPageChange="handlePerPageChange"
    /> -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { progressStatus } from '../../helpers'
import { VueGoodTable } from 'vue-good-table'

export default {
  name: 'Payments',
  components: {
    VueGoodTable,
    PaymentMethodsZeroState: () =>
      import('@/components/Billing/PaymentMethodsZeroState'),
    PaymentMethodLoader: () => import('./PaymentMethodLoader.vue'),
    PaymentMethodDropdown: () => import('./PaymentMethodDropdown.vue')
    // Pagination: () => import('@/components/Universal/Pagination')
  },

  data() {
    return {
      columns: [
        {
          label: '',
          field: 'brand',
          sortable: false,
          width: '20%'
        },
        {
          label: '',
          field: 'lastFour',
          sortable: false,
          width: '20%'
        },
        {
          label: '',
          field: 'expiryDate',
          sortable: false,
          width: '20%'
        },

        {
          label: '',
          field: 'action',
          sortable: false,
          width: '20%'
        }
      ],
      creditCardsConfig: {
        Visa: {
          name: 'Visa',
          brandIcon: 'visa_logo.png'
        },
        MasterCard: {
          name: 'MasterdCard',
          brandIcon: 'mastercard_logo.svg'
        },
        JCB: {
          name: 'JBC',
          brandIcon: 'jcb_logo.png'
        },
        Discover: {
          name: 'Discover',
          brandIcon: 'discover_logo.png'
        }
      },
      serverParams: {
        page: 0,
        perPage: 50
      }
    }
  },
  created() {
    this.getPaymentMethods({
      page: 1,
      perPage: this.serverParams.perPage
    })
  },
  methods: {
    ...mapActions('billing', ['getPaymentMethods']),
    mapBrand(brand) {
      let brandConfig = this.creditCardsConfig[brand]
      if (brandConfig) {
        return require(`../../assets/creditcards/${brandConfig.brandIcon}`)
      }
      return 'https://img.favpng.com/18/7/10/computer-icons-scalable-vector-graphics-bank-clip-art-png-favpng-7jAPKVG4TT32mr1GSE2QsDKL2.jpg'
    },
    maskCard(brand, lastFour) {
      return `${brand} *****${lastFour}`
    },
    markMethodAsPrimary(event, row) {
      this.$store.dispatch('billing/setDefaultPaymentMethod', row)
    },
    removePaymentMethod(event, row) {
      this.$store.dispatch('billing/deletePaymentMethod', row.id)
    },
    formatPhoneNumber(phoneNumber) {
      var cleaned = ('' + phoneNumber).replace(/\D/g, '')
      var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3]
      }
      return phoneNumber
    },
    pageChange(page) {
      this.updateParams({ page: page })
      this.getNextChuckOfPaymentMethod()
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },
    handlePerPageChange(e) {
      this.serverParams.perPage = e
      this.getNextChuckOfPaymentMethod()
    },
    getNextChuckOfPaymentMethod() {
      this.getPaymentMethods({
        page: this.serverParams.page + 1,
        perPage: this.serverParams.perPage
      })
    }
  },
  computed: {
    loadStatus() {
      return progressStatus(this.loadPaymentMethods)
    },
    ...mapState({
      loadPaymentMethods: state => state.billing.loadPaymentMethods,
      paymentMethods: state => state.billing.paymentMethods,
      totalRecords: state => state.billing.paymentMethodCount
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.button-gemnote,
.whitebutton-gemnote {
  height: 2.5rem;
  font-size: 0.813rem;
  width: auto;
  padding: 0 1.25rem;
}

.holder {
  height: 2.688rem;
  display: flex;
  align-items: center;
  color: $main-6;

  &.card {
    max-width: 3rem;
    width: 3rem;
  }

  img {
    max-height: inherit;
    object-fit: contain;
    height: inherit;
  }

  p {
    font-size: 0.813rem;
  }
}

.action-holder {
  width: 100%;
  max-width: 20rem;
  display: flex;
  height: 3rem;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;

  p {
    font-size: 0.813rem;
  }
}

@media (max-width: 768px) {
  .action-holder {
    width: 8rem;
  }
}

.make-primary {
  background: inherit;
  display: flex;
  height: 1.688rem;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-weight: normal;
  cursor: pointer;
  letter-spacing: 0.1px;
  border: 1px solid $onyx;
  border-radius: 40px;
  font-family: $inter;
  font-size: 0.625rem;
  padding: 0 0.875rem;
}

.remove-card {
  font-weight: 600;
  cursor: pointer;
  font-size: 0.875rem;
  // width: 12rem;
  height: 2.313rem;
  // max-width: 8rem;
  display: flex;
  align-items: center;
  color: $main-6;

  span {
    font-weight: normal;
    margin-left: 10px;
  }
}
.payment-method {
  margin-top: 2.5rem;
  &.header {
    display: flex;
    gap: 0.4rem;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 16px;
    &.mb-0 {
      margin-bottom: 0 !important;
    }
    .title {
      font-size: 0.913rem;
      font-weight: 700;
      width: max-content;
    }
    .subtitle {
      font-size: 0.713rem;
      font-weight: 400;
      color: #514d43;
      margin: 0 !important;
    }
  }
}

.empty-state {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  // margin-top: 1rem;
  border: 1px solid #a09c95;
  padding: 1.5rem;
  p {
    font-size: 0.8rem;
    font-weight: 400;
    color: #232220;
  }
}
</style>
